import { BaseModel } from '../../_base/crud';

export class WaterRateModel extends BaseModel {
	_id: string;
	nmrtewtr: string;
	rte: number;
	pemeliharaan: number;
	administrasi: number;
	perhitungan: number;
	batas_bawah: any;
	batas_menengah: any;
	batas_awal_menengah: any;
	batas_awal_atas: any;
	rte_batas_bawah: any;
	rte_batas_menengah: any;
	rte_batas_atas: any;


	clear(): void {
		this._id = undefined;
		this.nmrtewtr = "";
		this.rte = 0;
		this.pemeliharaan = 0;
		this.administrasi = 0;
		this.perhitungan = 1;

	}
}
